import { render, staticRenderFns } from "./FormularioNew.vue?vue&type=template&id=daae9498&scoped=true&"
import script from "./FormularioNew.vue?vue&type=script&lang=js&"
export * from "./FormularioNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daae9498",
  null
  
)

export default component.exports